import { checkInView, throttle } from './index';
import { cookie } from '@bilibili/ogv-fe-utils';

export function report(events, params, isH5) {
    if (window.reportObserver) {
        params = params || {};
        params.mid = cookie.get('DedeUserID');
        let spmObjKey = (window.reportConfig && window.reportConfig.msgObjects) ? window.reportConfig.msgObjects : '';
        if (window[spmObjKey]) {
            events = events || {};
            for (var k in events) {
                if (events.hasOwnProperty(k)) {
                    window[spmObjKey][k + '_' + events[k]] = params;
                    try {
                        window.reportObserver.forceCommit();
                    } catch (e) {}
                }
            }
        }
    } else {
        setTimeout(function () {
            report(events, params);
        }, 1000);
    }
}

export function parseUrl(url) {
    if (!url) return;
    if (url.indexOf('//') === 0) {
        return window.location.protocol + url;
    } else if (url.indexOf('/') === 0) {
        return location.origin + url;
    } else if (url.indexOf('http') === 0) {
        return url;
    } else {
        return location.href + url;
    }
}

// 曝光上报
export function repostShow({
    el,
    thresholdVal // 曝光的阈值
}) {
    let scrollTimer = null;
    let status = 0;
    const scrollEnd = function (e) {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
            if (status === 0 && checkInView(el, -el.offsetHeight * thresholdVal)) {
                status = 1;

                report();
                unbind();
            }
        }, 201);
    };

    const tProcess = throttle(scrollEnd, 200, 100);

    window.addEventListener('scroll', tProcess, false);

    const unbind = () => {
        window.removeEventListener('scroll', tProcess);
    };

    return unbind;
}

export const reportCustom = function (spmid = '0.0.0.0', data = {}, type = 'click') {
    try {
        if (window.reportObserver && window.reportObserver.reportCustomData) {
            if (window.requestIdleCallback) {
                window.requestIdleCallback(() => {
                    window.reportObserver.reportCustomData(type, {
                        msg: JSON.stringify(data),
                        spm_id: spmid
                    });
                });
            } else {
                window.reportObserver.reportCustomData(type, {
                    msg: JSON.stringify(data),
                    spm_id: spmid
                });
            }
        }
    } catch (e) {
        // log(JSON.stringify({
        //     typeMsg: '埋点上报失败',
        //     error: e && e.msg
        // }), 1);
    }
};
